import { LINKS_DESIGN_TYPE } from "../interfaces";

export default function shedules(): any[] {
    return [
        {            
            "border_radius": 0,
            "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'", 
            "gridColumns": "50% 50%",
            "gridRows": "auto",
            "className": "landing-card-grid-chess",
            "gap": 0,
            "card_fields": {
                "thumbnail": {
                    "style": {
                        "height": "100%",
                        "width": "100%",
                        minHeight: 250,
                    },                    
                    gridColumnCroupID: 2,
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 1,
                        "gridColumnEnd": 2,
                        "gridRowStart": 1,
                        "gridRowEnd": 7
                    },
                },
                "icon": {
                    width: 33,
                    height: 33,
                    "src": "assets/img/check.svg", 
                    gridColumnCroupID: 2,
                    "style": {
                        "height": "100%",
                        "width": "100%",
                        minHeight: 250,
                        
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 1,
                        "gridColumnEnd": 2,
                        "gridRowStart": 2,
                        "gridRowEnd": 3,
                    },
                },
                "order": {
                    "significant_zero": true, 
                    gridColumnCroupID: 2,
                    "card_fields_style": {
                        "position": "absolute",
                        "top": 10,
                        "right": 10, 
                    },
                    "style": {
                        display: "flex",
                        "borderRadius": 3,
                        "color": "#aa1414ff",
                        "fontFamily": "var(--fontTitleFamily)",
                        "fontSize": 25,
                        "opacity": 0.75,
                        "width": 60,
                        "height": 60, 
                        "justifyContent": "center",
                        "alignItems": "center",
                        "backgroundColor": "#FFFFFF",
                    }, 
                },
                "time": {
                    "style": { 
                        display: "flex",
                        position: "absolute",
                        top: "auto",
                        left: 0,
                        bottom: 0,
                        "justifyContent": "center",
                        "fontSize": 11,
                        "height": 20, 
                        minWidth: 180,
                    },
                    gridColumnCroupID: 2,
                    card_fields_style: {
                        "position": "absolute",
                        "bottom": 10,
                        "right": 10, 
                    },
                    "format": "D MMM YY года",
                    "className": "p-2 my-3 ml-4",
                    "labelClassName": "",
                    "minimal": 0,
                },
                "title": {
                    "style": {
                        "fontFamily": "var(--fontTitleFamily)",
                        "fontSize": 18,
                        "textAlign": "left",
                        "padding": 10, 
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 4,
                        "gridRowStart": 1,
                        "gridRowEnd": 2, 
                    },
                },
                "description": {
                    "max_length": 800,
                    "style": {
                        "paddingLeft": 20,
                        "textAlign": "left", 
                    },
                    card_fields_style: {  
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 4,
                        "gridRowStart": 2,
                        "gridRowEnd": 6, 
                    },
                },
                "person": {
                    "data": {
                        "avatarWidth": 100,
                        "avatarHeight": 100
                    }, 
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 4,
                        "gridRowStart": 4,
                        "gridRowEnd": 5,
                    },
                },
                "checkbox": { 
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 4,
                        "gridRowStart": 6,
                        "gridRowEnd": 6,
                        "padding": "10px 30px"
                    },
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Мудрость"
                        }
                    ],
                    "min": 0,
                    "max": 100,
                    "weight": 1, 
                    style: {  
                        "marginBottom": 10, 
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 4,
                        "gridRowStart": 6,
                        "gridRowEnd": 6,
                    },
                },
                "buttons": {
                    type: LINKS_DESIGN_TYPE.SMALL_ROUND,
                    "style": {
                        "height": "auto",
                        "padding": "7px 20px", 
                        marginBottom: 5
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 4,
                        "gridRowStart": 6,
                        "gridRowEnd": 6,
                    },
                }
            },
        },
        {            
            "border_radius": 5,
            "gap": 10,
            "card_fields": {
                "thumbnail": {
                    "style": {
                        "height": 250,
                        "backgroundColor": "var(--force-contrast-opacity-color)"
                    }
                },
                "icon": {
                    width: 33,
                    height: 33,
                    "src": "assets/img/check.svg",
                    "style": {
                        "height": 250,
                        "backgroundColor": "var(--force-contrast-opacity-color)"
                    }
                },
                "order": {
                    "significant_zero": true,
                    "card_fields_style": {
                        "position": "absolute",
                        "top": 10,
                        "right": 10
                    },
                    "style": {
                        "borderRadius": 3,
                        "color": "#146db6ff",
                        "fontFamily": "Yanone Kaffeesatz, sans-serif",
                        "fontSize": 25,
                        "opacity": 0.75,
                        "width": 60,
                        "height": 60,
                        "display": "flex",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "backgroundColor": "#FFFFFF"
                    }
                },
                "time": {
                    "card_fields_style": {
                        "position": "absolute",
                        "top": 220,
                        "left": 5
                    },
                    "style": {
                        "fontSize": 8,
                        "textTransform": "uppercase",
                        "letterSpacing": 2
                    },
                    "format": "D MMM YY года",
                    "className": "px-1",
                    "labelClassName": "",
                    "minimal": 0
                },
                "title": { 
                    "style": {
                        "fontWeight": 100,
                        "fontSize": 22,
                        "textAlign": "left",
                        "padding": 20,
                        "fontFamily": "var(--fontTitleFamily)"
                    }
                },
                "description": {
                    "max_length": 350,
                    "style": {
                        "paddingLeft": 20,
                        "textAlign": "left"
                    }
                },
                "person": {
                    "data": {
                        "avatarWidth": 33,
                        "avatarHeight": 33
                    }
                },
                "checkbox": {
                    "style": {
                        "padding": "10px 30px"
                    }
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Мудрость"
                        }
                    ],
                    "min": 0,
                    "max": 100,
                    "weight": 1,
                    "style": {
                        "marginBottom": 10
                    }
                },
                "buttons": {
                    type: LINKS_DESIGN_TYPE.SMALL_ROUND,
                    "style": {
                        "height": "auto",
                        "padding": "20px",
                        "paddingBottom": "auto"
                    }
                }
            },
        },
        {            
            "border_radius": 5,
            "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'", 
            "gridColumns": "25% auto 180px",
            "gridRows": "auto",
            "gap": 10,
            "card_fields": {
                "thumbnail": {
                    "style": {
                        "height": "100%",
                        "width": "100%",
                        minHeight: 150,
                    },
                    hover_size: 10,
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 1,
                        "gridColumnEnd": 2,
                        "gridRowStart": 1,
                        "gridRowEnd": 6 
                    },
                },
                "icon": {
                    width: 33,
                    height: 33,
                    "src": "assets/img/check.svg",
                    "style": {
                        "height": "100%",
                        "width": "100%",
                        minHeight: 100,
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 1,
                        "gridColumnEnd": 2,
                        "gridRowStart": 3,
                        "gridRowEnd": 4
                    },
                },
                "order": {
                    "significant_zero": true,
                    "card_fields_style": {
                        "position": "absolute",
                        "top": 10,
                        "right": 10,
                         "display": "grid",
                        "gridColumnStart": 1,
                        "gridColumnEnd": 2,
                        "gridRowStart": 1,
                        "gridRowEnd": 2
                    },
                    "style": {
                        "borderRadius": 3,
                        "color": "#b419a0ff",
                        "fontFamily": "var(--fontTitleFamily)",
                        "fontSize": 25,
                        "opacity": 0.75,
                        "width": 60,
                        "height": 60,
                        "display": "flex",
                        "justifyContent": "center",
                        "alignItems": "center",
                        "backgroundColor": "#FFFFFF"
                    }
                },
                "time": {
                    "style": {
                        "display": "flex",
                        "justifyContent": "start",
                        "fontSize": 11,
                        "height": 20
                    },
                    "format": "D MMM YY года",
                    "className": "p-2 my-3 ml-4",
                    "labelClassName": "",
                    "minimal": 0,
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 3,
                        "gridColumnEnd": 3,
                        "gridRowStart": 1,
                        "gridRowEnd": 1
                    },
                },
                "title": { 
                    "style": {
                        "fontSize": 22,
                        lineHeight: 1.1,
                        justifyContent: "flex-start",
                        "textAlign": "left",
                        "paddingLeft": 20,
                        "fontFamily": "var(--fontTitleFamily)"
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 2,
                        "gridRowStart": 1,
                        "gridRowEnd": 2
                    },
                },
                "description": {
                    "max_length": 350,
                    "style": {
                        "paddingLeft": 20,
                        "textAlign": "left"
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 2,
                        "gridRowStart": 2,
                        "gridRowEnd": 3
                    },
                },
                "person": { 
                    "avatarWidth": 100,
                    "avatarHeight": 100,
                    isVertical:true,
                    border: { 
                        borderRound: {
                            border: 100,
                        },
                    },
                    card_fields_style: {
                        "display": "grid",
                        "gridColumnStart": 3,
                        "gridColumnEnd": 3,
                        "gridRowStart": 2,
                        "gridRowEnd": 6
                    },
                },
                "checkbox": {
                    "style": {
                        "padding": "10px 30px"
                    },
                    card_fields_style: {
                         "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 2,
                        "gridRowStart": 3,
                        "gridRowEnd": 3
                    },
                },
                "statistic_line": {
                    "items": [
                        {
                            "id": "3",
                            "title": "Талант"
                        },
                        {
                            "id": "4",
                            "title": "Мудрость"
                        }
                    ],
                    "min": 0,
                    "max": 100,
                    "weight": 1,
                    "style": {
                        "marginBottom": 10
                    },
                    card_fields_style: {
                         "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 2,
                        "gridRowStart": 4,
                        "gridRowEnd": 4
                    },
                },
                "buttons": {
                    design_type: LINKS_DESIGN_TYPE.SQUARE,
                    "style": {
                        "height": "auto",
                        "padding": "6px 20px",
                        "paddingBottom": "auto"
                    },
                    card_fields_style: {
                         "display": "grid",
                        "gridColumnStart": 2,
                        "gridColumnEnd": 2,
                        "gridRowStart": 5,
                        "gridRowEnd": 5
                    },
                }
            },
        }
    ]
}